import axiosInstance from "../lib/axiosInstance";


const Baseurl = process.env.REACT_APP_API_URL


const walletModel = class {

    async get() {
        return await axiosInstance.get(Baseurl +`/users/wallet/history`);
    }
    
}

export default new walletModel();